import { Component, OnInit, Input } from '@angular/core';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';

@Component({
  selector: 'app-property-premarketing',
  templateUrl: './property-premarketing.component.html',
  styleUrls: ['./property-premarketing.component.css']
})
export class PropertyPremarketingComponent implements OnInit {

  @Input() propertyId: number;
  premarketingList = [];
  singelPremarketingList = [];
  isEditable = false as boolean;

  constructor(private _dashboardService: DashboardService,
    private _authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.isEditable = (this._authenticationService.Admin() || this._authenticationService.Broker() || this._authenticationService.SuperAdmin());
    this.loadContent();
  }

  loadContent() {
    this._dashboardService.getPropertyPremarketingDetails(this.propertyId).subscribe(res => {

      this.singelPremarketingList = res.filter(x => x.PremaretingStatusList.length <= 1 && x.AssociatedStatusName == x.PremaretingStatusList[0].TaskName);
      this.premarketingList = res.filter(x => x.PremaretingStatusList.length > 1 || x.AssociatedStatusName != x.PremaretingStatusList[0].TaskName);
    })
  }

  saveStatus(data) {
    this._dashboardService.savePropertyPremarketingStatus(this.propertyId, data.Id, data.IsChecked).subscribe(res => {
      if (res) {

      }
    })
  }

  checkFullCompleted(data) {
    return data.PremaretingStatusList.filter(x => !x.IsChecked).length > 0 ? false : true;
  }

  updateChild(isChecked, data) {
    data.PremaretingStatusList.forEach(item => {
      item.IsChecked = isChecked;
      this.saveStatus(item);
    });
  }

}
